import styled from 'styled-components';
import { Card } from '@interstate/components/Card';

export const CardList = styled.div`
    .MuiCard-root {
        padding: 1.142rem;
        &:first-of-type:not(:only-of-type) {
            border-bottom: none;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
        }

        &:last-of-type:not(:only-of-type) {
            border-top-left-radius: 0;
            border-top-right-radius: 0;
        }

        .card-header-content-container {
            padding: 0;
            margin-bottom: 1.142rem;
        }
    }
`;

type CardContainerProps = {
    isAddressCard?: boolean;
};

export const CardContainer = styled(Card)<CardContainerProps>`
    ${({ isAddressCard }) => (isAddressCard ? 'background: #F4F4F4 !important' : '')}
`;

export const CardHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: 0.5rem;
`;

export const AddressContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
`;
export const PopoverRow = styled.div`
    display: flex;
    flex-direction: column;
    margin-right: -0.375rem;
`;

export const LoadingIndicatorWrapper = styled.div<{ hasMultipleAddresses?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: ${({ hasMultipleAddresses }) => (hasMultipleAddresses ? '15rem' : '7.5rem')};
`;

export const AddressCopyContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    margin-bottom: 1rem;
`;

export const CheckBoxSection = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.25rem;
`;
